import { render, staticRenderFns } from "./VendaOrcamentoLista.vue?vue&type=template&id=0708372a&scoped=true"
import script from "./VendaOrcamentoLista.vue?vue&type=script&lang=js"
export * from "./VendaOrcamentoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708372a",
  null
  
)

export default component.exports